import React from "react";
import { Container, Row, Col } from 'reactstrap';
import './announcement.css';
import { CaretRightIcon } from './Icons';

export default class Announcement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isRunningTextLoading: true,
            runningTextList: ["", ""],
        };
    }

    async loadContent(url) {
        try {
            const response = await fetch(url);
            const data = await response.json();
            return data;
        }
        catch {
            console.log("Error");
            return [];
        }
    }

    async loadRunningText() {
        var url = 'api/Content/GetRunningText';
        var result = await this.loadContent(url);
        if (result !== null && result.length <= 0) {
            console.error(result);
        } else {
            this.setState({ runningTextList: result });
        }
    }

    async componentDidMount() {
        this.loadRunningText();
    }

    renderRunningText(textList) {
        return <div className='main-banner-announce subtitle2'>
            <Container>
                <Row>
                    <Col>
                        <div className="main-banner-announce-inner">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.32438 8.12445L19.83 3.06195C20.0534 2.99679 20.2889 2.98451 20.5179 3.02606C20.7468 3.06762 20.963 3.16188 21.1493 3.30139C21.3355 3.4409 21.4867 3.62183 21.591 3.82988C21.6953 4.03792 21.7497 4.26737 21.75 4.50008V18.0001C21.75 18.3979 21.592 18.7794 21.3107 19.0607C21.0294 19.342 20.6478 19.5001 20.25 19.5001C20.1066 19.5001 19.9639 19.4796 19.8262 19.4391L12 17.0373V18.0001C12 18.3979 11.842 18.7794 11.5607 19.0607C11.2794 19.342 10.8978 19.5001 10.5 19.5001H7.5C7.10218 19.5001 6.72064 19.342 6.43934 19.0607C6.15804 18.7794 6 18.3979 6 18.0001V15.197L3.32438 14.3766C3.01471 14.2836 2.74313 14.0935 2.54969 13.8344C2.35626 13.5753 2.2512 13.2609 2.25 12.9376V9.56258C2.2514 9.2394 2.35655 8.92521 2.54997 8.6663C2.7434 8.40739 3.01486 8.21745 3.32438 8.12445ZM12 15.4688L20.25 18.0001V4.50008L12 7.03133V15.4688ZM7.5 18.0001H10.5V16.577L7.5 15.6563V18.0001ZM3.75 12.9376H3.76031L10.5 15.0076V7.49258L3.76031 9.55508H3.75V12.9301V12.9376Z" fill="white" />
                            </svg>
                            <div>
                                <div className="marquee-container">
                                    <p className="marquee">
                                        <span>{textList.map((text, idx) => <b key={idx} className="mr-4" style={{ fontWeight: 'normal', paddingRight: '120px'}} >{`${text} `}</b>)} </span>
                                    </p>
                                </div>
                            </div>
                            <CaretRightIcon />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>;
    }

    render() {
        return this.renderRunningText(this.state.runningTextList);
    }
}